import {
	FacetValue,
	FacetValues,
	IComponentBindings,
	IQuerySuccessEventArgs,
	IFacetOptions,
	Initialization,
	QueryEvents
} from 'coveo-search-ui';

import gtmCapture from './GTM-Capture';

import * as $ from 'jquery';

export class CustomFacet extends Coveo.Facet {
	static ID = 'CustomFacet';
	public allowCollapsing: Boolean;
	public collapseOnLoad: Boolean;
	private $expand: JQuery;
	private $collapse: JQuery;
	private $element: JQuery;
	private scroll: number = null;
	private isRunOnce: Boolean = false;
	private selectAllCaption: string = '*Select all';

	constructor(public element: HTMLElement, public options: IFacetOptions, bindings?: IComponentBindings, facetClassId: string = CustomFacet.ID) {
		super(element, options, bindings, facetClassId);
		this.$element = $(this.element);
		this.allowCollapsing = this.$element.attr("data-atlas-enable-collapse") === "True";
		this.collapseOnLoad = this.$element.attr("data-atlas-collapse-on-load") === "True";

		this.bind.onRootElement(QueryEvents.querySuccess, (data: IQuerySuccessEventArgs) => {
			this.handleQuerySuccess(data);
//
//			FacetValues.prototype.sortValuesDependingOnStatus = function (excludeLastIndex?: number) {
//				this.values = _.sortBy(this.values, (value: FacetValue) => {
//					return 1;
//				});
//				if (excludeLastIndex != null && excludeLastIndex < this.values.length) {
//					var nbExclude = this.getExcluded().length;
//					var excludes = this.values.splice(this.values.length - nbExclude, nbExclude);
//					Array.prototype.splice.apply(this.values, (<any[]>[excludeLastIndex - nbExclude, 0]).concat(excludes));
//				}
//			}
		});
	}

    public createDom() {

        $(".results .sidebar-inner, .results .results-header").on('DOMNodeInserted', function () {
            let scrollBackTime = 400;
            let scrollDelay = 450;
            if (!$(this).hasClass("initScrollLock")) {
                $(this).addClass("initScrollLock");
                this.addEventListener('click', function (e) {
                    let event = e;
					let x = window.scrollX;
					let y = window.scrollY;
                    let toggleElClasses: Array<string> = [
						'coveo-facet-value-caption',
						'coveo-facet-value-checkbox',
						'CoveoResetFilters'
					];
					window.onscroll = function () {
						window.scrollTo(x, y);
					};
					window.setTimeout(function () {
						window.onscroll = function () { };
					}, 250);
                    window.setTimeout(function () {
						let $stickySidebar = $('.results .sticky-sidebar');
                        let innerHeight = $stickySidebar.height();
                        let pageHeader = $('.page-header');
                        let pageHeaderOffsetTop = pageHeader.offset().top;
                        let $siteHeader = $('header.site-header');
                        let heaterHeight = $siteHeader.outerHeight();
                        let innerOffsetTop = $stickySidebar.offset().top;
                        let checkedInput = $stickySidebar.find('input[checked="checked"]');
						let isClickedOnToggle : boolean = toggleElClasses.some(function(v) {
							return event.target.className.indexOf(v) >= 0;
						});
						event.preventDefault();

						//Prevent scroll when clicked on "+" or "-"
						if (!isClickedOnToggle) {
							return false;
						}
                        if (checkedInput.length > 0) {
                            let checkedInputOffsetTop = $stickySidebar.find('input[checked="checked"]:last').offset().top;
                            if (checkedInputOffsetTop < document.documentElement.scrollTop) {
                                $("html").stop().animate({ scrollTop: checkedInputOffsetTop - pageHeaderOffsetTop }, scrollBackTime, 'swing');
                            }
                        }
                        else if (innerOffsetTop + innerHeight < document.documentElement.scrollTop) {
                            $("html").stop().animate({ scrollTop: innerOffsetTop - heaterHeight * 2 }, scrollBackTime, 'swing');
                        } else {
							//scroll to top screen when nothing is checked
							$("html").stop().animate({ scrollTop: pageHeaderOffsetTop}, scrollBackTime, 'swing');

							//make shure site-header isHidden
							window.setTimeout(() => {
								$siteHeader.addClass('unpinned')
							}, scrollDelay + 50);
						}

                    }, scrollDelay);
                })
            }
        });

		super.createDom();

		if (this.allowCollapsing) {
			this.enableCollapseExpand();
		}

		if (this.collapseOnLoad) {
			this.collapse();
		} else {
			this.expand();
		}
	}

	public expand() {
		super.expand();
		if (this.allowCollapsing) {
			this.$collapse.show();
			this.$expand.hide();
		}
	}

	public collapse() {
		super.collapse();
		if (this.allowCollapsing) {
			this.$collapse.hide();
			this.$expand.show();
		}
	}

	private enableCollapseExpand() {
		var $container = $("<div class='coveo-toggle'></div>");
		this.$expand = $("<div class='expand'></div>");
		this.$collapse = $("<div class='collapse'></div>");
		$container.append([this.$expand, this.$collapse]);
		$(".coveo-facet-header", this.element)
			.append($container)
			.on("click", () => {
				if (this.$expand.is(":visible")) this.expand();
				else this.collapse();
			});
	}

	public deselectValue(value: FacetValue): void;
	public deselectValue(value: string): void;
	public deselectValue(value: any) {
		this.scroll = $(window).scrollTop();
		super.deselectValue(value);
	}

	private handleQuerySuccess(data: IQuerySuccessEventArgs) {
		if (this.scroll !== null) {
			$(window).scrollTop(this.scroll);
            this.scroll = null;
		}
	}

	private pushAnalyticData(event, $rootFacet){
		const $targetLabel = $(event.target).closest('li');
		const $elValue = $targetLabel.data('value');
		const $elCheckbox = $(event.target).closest('label').find('input[type="checkbox"]');
		const $filterSection = $rootFacet.find('.coveo-facet-header .coveo-facet-header-title');

		gtmCapture({$elCheckbox, $filterSection, $elValue});
	}

	protected rebuildValueElements() {

		super.rebuildValueElements();

		let selectMultipleValues = super.selectMultipleValues.bind(this);
		let deselectMultipleValues = super.deselectMultipleValues.bind(this);
		let $this = this;

		// Clone the next child and reuse it for "Select all" checkbox
		let firstItem = $("li.coveo-facet-value.coveo-facet-selectable", this.element).first();
		let cloned = firstItem.clone();
		cloned.find('.coveo-facet-value-caption').removeAttr("title").text(this.selectAllCaption);
		cloned.attr('data-value', this.selectAllCaption);
		cloned.find('.coveo-facet-value-count').remove();
		cloned.insertBefore(firstItem);
		cloned.children('div[title]:first').removeAttr('title');


		let values: string[] = [];
		let currentElement = cloned;
		let select: boolean = false;
		while (true) {
			let nextChild = currentElement.next("li.coveo-facet-value");
			if (nextChild.length > 0) {
				let unChecked = nextChild.find(":checkbox").not(":checked").length;
				if (unChecked) {
					// If at least one child is unchecked - select all, otherwise - unselect
					select = true;
				}
				let facetValue = nextChild.attr("data-value");
				values.push(facetValue);
				currentElement = nextChild;
			} else {
				break;
			}
		}

		cloned.find(":checkbox").prop('checked', !select);

		cloned.unbind("click").click(function (e) {
			if(this.isRunOnce) {
				this.isRunOnce = !this.isRunOnce;
				return;
			}
			if (values.length > 0) {

				if (select) {
					selectMultipleValues(values, true);
				} else {
					deselectMultipleValues(values, true);
					$this.scroll = $(".facet-filters").offset().top;
				}

				// Update search results
				$this.keepDisplayedValuesNextTime = true;
				$this.updateSort('alphaascending');
				Coveo.executeQuery($this.root);
				$this.pushAnalyticData(e, $($this.$element));
			}
			this.isRunOnce = !this.isRunOnce;
		});

		$(this.$element).find('ul li.coveo-facet-selectable').on('click', function () {
			const $targetLabel = $(event.target).closest('label');
			const $elValue = $targetLabel.find('.coveo-facet-value-caption').text();

			//skip for 'select all' since it was called from cloned elem
			if ($elValue !== $this.selectAllCaption) {
				$this.pushAnalyticData(event, $($this.$element));
			}
		});
	}
}

Initialization.registerAutoCreateComponent(CustomFacet);



// WEBPACK FOOTER //
// ./src/source/Atlas.SEF.Feature.Common/Areas/AtlasCommon/Assets/Search/components/CustomFacet.ts